import "core-js/modules/es7.array.includes.js";
export default {
  isEnabled: _ref => {
    var {
      features
    } = _ref;
    return flag => features.includes(flag);
  }
};